'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

exports.default = (0, _lodash.memoize)(function () {
    if (typeof window !== 'undefined') return window.__clientconf;
    if (typeof global !== 'undefined') return global.__clientconf;
    throw new Error('Could not load client config from window or global');
});


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/getClientConfig.js
// module id = 48
// module chunks = 0